import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTinyletterComponent } from './simple-icons-tinyletter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTinyletterComponent ],
    exports:      [ SimpleIconsTinyletterComponent ],
    bootstrap:    []
})
export class SimpleIconsTinyletterModule {}
